export enum PanelTypes  {

	Route = "Route",
	Phase = "Phase",
	Shipment = "Shipment",
	None = "None"
	
}
